import { createGtm } from '@gtm-support/vue-gtm';
import { defineBoot } from '@quasar/app-vite/wrappers';

/**
 * Adds the @gtm-support/vue-gtm plugin.
 *
 * @param {{ router: VueRouter, urlPath: string, app: import('vue').App }} params
 */
export default defineBoot(({ app, router, urlPath }) => {
  // don't run in iframe, minimal app context
  if (urlPath.startsWith('/frame')) {
    return;
  }
  app.use(
    createGtm({
      id: 'GTM-P2TDPXG',
      vueRouter: router,
    })
  );
});
